var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.33333V6.66667C15 4.08934 12.9107 2 10.3333 2C7.756 2 5.66667 4.08934 5.66667 6.66667V8.33333M10 12.5V14.1667M7.33333 18H12.6667C14.0668 18 14.7669 18 15.301 17.7275C15.7699 17.4878 16.1545 17.1032 16.3942 16.6343C16.6667 16.1002 16.6667 15.4001 16.6667 14V12.6667C16.6667 11.2665 16.6667 10.5665 16.3942 10.0323C16.1545 9.56346 15.7699 9.17883 15.301 8.93915C14.7669 8.66667 14.0668 8.66667 12.6667 8.66667H7.33333C5.93319 8.66667 5.23312 8.66667 4.69898 8.93915C4.23008 9.17883 3.84546 9.56346 3.60578 10.0323C3.33333 10.5665 3.33333 11.2665 3.33333 12.6667V14C3.33333 15.4001 3.33333 16.1002 3.60578 16.6343C3.84546 17.1032 4.23008 17.4878 4.69898 17.7275C5.23312 18 5.93319 18 7.33333 18Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.96390b1065bc8429cbbb11e506c60812.svg";
export { ForwardRef as ReactComponent };